<template>
  <div>
    <a-card style="margin: 10px 0">
      <div class="filter-section">
        <a-form layout="inline" ref="form" :model="form">
          <a-form-item label="数据类型" name="itemTypeId">
            <a-select
              style="width: 140px"
              v-model:value="form.itemTypeId">
              <a-select-option key="">
                全部
              </a-select-option>
              <a-select-option
                v-for="t in dataTypeList"
                :key="t.id">
                {{ t.chineseInstructions }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item name="chineseInstructions">
            <a-input style="width: 200px" placeholder="请输入名称" v-model:value="form.chineseInstructions" autocomplete="off">
              <template v-slot:suffix><search-outlined type="user"/></template>
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-button @click="resetForm">重置</a-button>
            <a-button type="primary" @click="getData()">查询</a-button>
          </a-form-item>
        </a-form>
      </div>
    </a-card>
    <a-card>
      <div class="table-title">
        <p class="table-name">数据集列表</p>
      </div>
      <a-table
        :columns="columns"
        :data-source="tableData"
        rowKey="id"
        :pagination="false"
        :loading="searchloading"
        >
        <template v-slot:itemType="{ text }">
          {{ getDataTypeName(text) }}
        </template>
        <template v-slot:userId="{ text }">
          {{ getUserName(text) }}
        </template>
        <template v-slot:time="{ text }">
          {{ getDateTime(text) }}
        </template>
        <template v-slot:updateTime="{ text }">
          {{ getDateTime(text) }}
        </template>
        <template v-slot:team="{ text }">
          {{ getTeamName(text) }}
        </template>
        <template v-slot:action="{ record }">
          <span class="gap-btn">
            <a @click="handlePreview(record)">预览</a>
          </span>
          <span class="gap-btn">
            <a @click="toDetail(record)">详情</a><span v-if="record.state == 'creating'">(创建中)</span>
          </span>
          <span class="gap-btn"
            v-if="btnPerm.download.add.indexOf(currentRole.roleId) !== -1">
            <a @click="openDownload(record)">创建下载</a>
          </span>
          <!-- <span class="gap-btn">
            <a @click="toCreateTask(record)">创建标注任务</a>
          </span> -->
          <span class="gap-btn"
            v-if="btnPerm.dataset.delete.indexOf(currentRole.roleId) !== -1">
            <a @click="showDeleteConfirm(record)">删除</a>
          </span>
        </template>
      </a-table>
      <br>
      <a-pagination
        :current="page.pageNum"
        show-quick-jumper
        :pageSize="10"
        :total="total"
        :show-total="total => `共 ${total} 条`"
        @change="getData"
      ></a-pagination>
    </a-card>

    <create-task ref="createTask" dialogType="add" :dataSetId="currentDataSet.id"></create-task>
    <PreviewDialog ref="preview" :currentDataSet="currentDataSet"></PreviewDialog>
    <DownloadDialog ref="downloadDialog" :currentDataSet="currentDataSet"></DownloadDialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { SearchOutlined } from '@ant-design/icons-vue'
import { getDataSetByPage, deleteDataSet } from '@/api/dataSet'
import { getDateTime, getTeamName, getUserName, getDataTypeName } from '@/filters'
import PreviewDialog from './Preview'
import DownloadDialog from '../DataDownload/DownloadDialog'
import CreateTask from '@/views/TaskManage/TaskRelease/CreateTask'
import config from '@/config'
const columns = [
  {
    title: '名称',
    dataIndex: 'chineseInstructions'
  },
  {
    title: '说明',
    dataIndex: 'remark'
  },
  {
    title: '数据类型',
    dataIndex: 'itemTypeId',
    slots: { customRender: 'itemType' }
  },
  {
    title: '创建人',
    dataIndex: 'createUserId',
    slots: { customRender: 'userId' }
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    slots: { customRender: 'time' }
  },
  {
    title: '更新时间',
    dataIndex: 'updateTime',
    slots: { customRender: 'updateTime' }
  },
  {
    title: '团队',
    dataIndex: 'teamId',
    slots: { customRender: 'team' }
  },
  {
    title: '操作',
    slots: { customRender: 'action' }
  }
]

export default {
  components: {
    SearchOutlined,
    PreviewDialog,
    DownloadDialog,
    CreateTask
  },
  data () {
    return {
      btnPerm: config.btnPerm,
      searchloading:true,
      form: {
        // labelGoOnState: '',
        chineseInstructions: '',
        itemTypeId: ''
      },
      tableData: [],
      columns,
      page: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      currentDataSet: {}
    }
  },
  computed: {
    ...mapState(['currentRole', 'dataTypeList'])
  },
  mounted () {
    this.getData()
  },
  methods: {
    getDateTime,
    getTeamName,
    getUserName,
    getDataTypeName,
    resetForm () {
      this.$refs.form.resetFields()
    },
    getData (pageNum) {
      if (pageNum) this.page.pageNum = pageNum
      this.searchloading = true;
      getDataSetByPage({ ...this.form, ...this.page }).then(res => {
        this.searchloading = false;
        const data = res.data.map.data
        this.total = data.total
        data.rows.forEach((element)=>{
          if(element.children.length <= 0){
            element.children = '';
          }
        })
        this.tableData = data.rows
        
        
      })
    },
    handlePreview (item) {
      this.currentDataSet = item
      this.$refs.preview.open()
    },
    toDetail (item) {
      console.log(item)
      this.$router.push({
        path: `/itemList/${item.id}`
      })
    },
    // 创建下载包
    openDownload (item) {
      if(item.state == 'creating'){
        alert("数据集创建中，请稍候！");
        this.getData();
        return;
      }
      this.currentDataSet = item
      this.$refs.downloadDialog.open()
    },
    // 单个删除确认
    showDeleteConfirm (item) {
      this.$confirm({
        title: '删除数据集',
        content: '确认删除数据集？',
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        onOk: () => {
          this.handleDelete([item.id])
        },
        onCancel () {
          console.log('cancel')
        }
      })
    },
    // 删除
    async handleDelete (ids) {
      this.loading = true
      for (const id of ids) {
        await deleteDataSet(id).catch(e => e)
      }
      this.loading = false
      this.getData()
    },
    toCreateTask (record) {
      this.$message.info('功能未开放')
      // this.currentDataSet = record
      // this.$refs.createTask.open()
    }
  }
}
</script>
<style>
.gap-btn {
  margin: 0 5px;
}
</style>
